<a [routerLink]="pageUrl + course?.id" *ngIf="pageUrl?.length">
    <ng-container [ngTemplateOutlet]="item"></ng-container>
</a>

<div *ngIf="!pageUrl?.length">
    <ng-container [ngTemplateOutlet]="item"></ng-container>
</div>

<ng-template #item>
    <div class="course-card d-flex flex-column flex-lg-row my-3" [class.card-link]="pageUrl?.length">
        <div class="col-lg-6 col-12">
            <div class="course-icon">
                <img [src]="course?.image" [alt]="course?.title || ('Курс' | transloco)">
            </div>
        </div>
        <div class="col-lg-6 col-12 p-lg-3">
            <div class="course-cont d-flex flex-column align-items-start justify-content-center">
                <h3 class="mb-3">{{ course?.title }}</h3>
                <h4 *ngIf="course?.design?.name?.length">{{ 'Категория:' | transloco }} {{ course?.design?.name }}</h4>

                <div class="row text-muted mb-3">
                    <div class="col-auto my-1">
                        <i class="fa-solid fa-tag fa-fw text-dark"></i>
                        {{ course?.price | price }}
                    </div>
                    <div class="col-auto my-1" *ngIf="course?.parsed_starting">
                        <i class="fa-solid fa-calendar-check fa-fw text-dark"></i>
                        {{ course?.parsed_starting|dateLocale:"d MMMM y" }}
                    </div>
                    <div class="col-auto my-1" *ngIf="course?.duration">
                        <i class="fa-solid fa-hourglass-end fa-fw text-dark"></i>
                        {{ '\{{weeks}\} седмици' | transloco:{weeks: course?.duration ?? '0'} }}
                    </div>
                    <div class="col-auto my-1">
                        <i class="fa-solid fa-trophy fa-fw text-dark"></i>
                        {{ course?.presents ? ('С награди' | transloco) : ('Без награди' | transloco) }}
                    </div>
                </div>

                <p *ngIf="!pageUrl?.length">
                    {{ ((course?.description ?? '').length > 200)? (course?.description | slice:0:200)+'...':(course?.description) }}
                </p>

                <div class="my-auto w-100 pe-md-4 d-flex align-items-end justify-content-end" >
                    <div class="btn btn-primary d-lg-block d-none py-2 px-3 my-2" *ngIf="pageUrl?.length">
                        <span>{{ 'Към курса' | transloco }}</span>
                    </div>
                </div>

                <ng-content></ng-content>
            </div>
        </div>
    </div>
</ng-template>
